<template>
  <div>
    <navbar />
    <main class="profile-page">
      <section class="relative block h-500-px">
        <div
          class="absolute top-0 w-full h-full bg-center bg-cover"
          style="
            background-image: url('https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80');
          "
        >
          <span
            id="blackOverlay"
            class="w-full h-full absolute opacity-50 bg-black"
          />
        </div>
        <div class="container relative mx-auto">
          <div class="w-full lg:w-8/12 px-4 pt-32 ml-auto mr-auto text-center">
            <h3
              class="text-4xl font-semibold leading-normal mb-2 text-white mb-2"
            >
              It's not just us
            </h3>
            <p class="text-lg font-semibold text-blueGray-200">
              Here is what your neighbors have experienced with speeding on Fairway Drive.
            </p>
          </div>
        </div>
        <div
          class="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
          style="transform: translateZ(0);"
        >
          <svg
            class="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              class="text-blueGray-200 fill-current"
              points="2560 0 2560 100 0 100"
            />
          </svg>
        </div>
      </section>
      <section class="relative py-16 bg-blueGray-200">
        <div class="flex flex-wrap space-y-4 md:space-y-0">
          <div class="space-y-4 max-w-md mx-auto">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              class="w-8 fill-teal-500" 
              viewBox="0 0 35 30" 
              fill="none"
            >
              <path
                d="M22.3838 27.6777C23.5264 28.9961 25.3721 29.6992 27.4814 29.6992C31.6123 29.6992 34.249 26.9746 34.249 22.7559C34.249 18.625 31.5244 15.6367 27.6572 15.6367C26.8662 15.6367 25.9873 15.8125 25.1084 16.0762C24.5811 9.48438 27.833 4.03516 32.2275 2.36523L31.7881 0.871094C24.2295 3.77148 19.4834 11.1543 19.4834 19.8555C19.4834 22.668 20.5381 25.7441 22.3838 27.6777ZM0.499023 19.8555C0.499023 24.6895 3.22363 29.6992 8.49707 29.6992C12.54 29.6992 15.1768 26.9746 15.1768 22.7559C15.1768 18.625 12.4521 15.6367 8.67285 15.6367C7.88184 15.6367 7.00293 15.8125 6.12402 16.0762C5.59668 9.48438 8.84863 4.03516 13.2432 2.36523L12.7158 0.871094C5.24512 3.77148 0.499023 11.1543 0.499023 19.8555Z"
              />
            </svg>
            <p class="md:text-lg leading-relaxed">
              It's incredibly easy to integrate into our applications, and it has saved us countless hours of development time.
            </p>
            <div class="flex items-center gap-2">
              <img 
                alt="Yifan testimonial for ShipFast"
                loading="lazy" 
                width="48" 
                height="48" 
                decoding="async" 
                data-nimg="1" 
                class="w-10 h-10 rounded-full object-cover" 
                src="https://images.unsplash.com/photo-1566492031773-4f4e44671857?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w0NzEyNjZ8MHwxfHNlYXJjaHwxMnx8bWFufGVufDB8MXx8fDE2OTYxNzE4MzN8MA&ixlib=rb-4.0.3&q=80&w=1080"
              >
              <p>Yifan, <span class="font-bold">John Doe</span></p>
            </div>
          </div>
          <div class="w-full md:w-4/12 px-4 text-center">
            <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full h-full shadow-lg rounded-lg"
            >
              <div class="px-4 py-5 flex-auto">
                <div
                  class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400"
                >
                  <i class="fas fa-award" />
                </div>
                <h6 class="text-xl font-semibold">
                  Our Mission
                </h6>
                <p class="mt-2 mb-4 text-blueGray-500">
                  To reduce the dangerous speeding on Fairway Drive before someone is seriously hurt or killed.
                </p>
              </div>
            </div>
          </div>

          <div class="w-full md:w-4/12 px-4 text-center">
            <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full h-full shadow-lg rounded-lg"
            >
              <div class="px-4 py-5 flex-auto">
                <div
                  class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-lightBlue-400"
                >
                  <i class="fas fa-question" />
                </div>
                <h6 class="text-xl font-semibold">
                  What are we doing about it?
                </h6>
                <p class="mt-2 mb-4 text-blueGray-500">
                  We have been working with the Fairfax County Department of Transportation (FCDOT) on a plan to install traffic calming 
                  measures to reduce speeding on Fairway Drive.
                </p>
                <a
                  class="font-bold uppercase text-blueGray-700 mt-8"
                  href="docs/Current Proposal.pdf"
                  target="_blank"
                >
                  <button
                    class="w-full bg-indigo-500 text-white active:bg-indigo-600 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                  >
                    Current Conceptual Plan
                  </button>
                </a>
              </div>
            </div>
          </div>

          <div class="w-full md:w-4/12 px-4 text-center">
            <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full h-full shadow-lg rounded-lg"
            >
              <div class="px-4 py-5 flex-auto">
                <div
                  class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-emerald-400"
                >
                  <i class="fas fa-thumbs-up" />
                </div>
                <h6 class="text-xl font-semibold">
                  We Need You
                </h6>
                <p class="mt-2 mb-4 text-blueGray-500">
                  Once we have an approved plan, you will be asked to vote on it to make our road safer.  We need you to support the plan and vote "Yes".  
                  The plan won't happen without your vote.
                </p>
                <!--
                <div
                  class="w-full bg-blueGray-500 text-blueGray-200 cursor-not-allowed text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                  title="We will post the voting area once it's determined by FCDOT"
                >
                  COMING SOON - Who will need to vote?
                </div>
                -->
                <a
                  class="font-bold uppercase text-blueGray-700 mt-8 flex"
                  href="docs/Fairway Drive (West) Ballot Area.pdf"
                  target="_blank"
                  style="margin-top: auto;"
                >
                  <button
                    class="w-full bg-indigo-500 text-white active:bg-indigo-600 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 disabled:bg-gray-400 disabled:text-gray-200 disabled:cursor-not-allowed"
                    type="button"
                  >
                    Who will need to vote?
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <footer-component />
  </div>
</template>
<script>
import Navbar from "@/components/Navbars/AuthNavbar.vue";
import FooterComponent from "@/components/Footers/Footer.vue";

import team2 from "@/assets/img/team-2-800x800.jpg";

export default {
  components: {
    Navbar,
    FooterComponent,
  },
  data() {
    return {
      team2,
    };
  },
};
</script>
